import { ChangeDetectorRef, Component, ElementRef, NgZone, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { LoginService } from "../../services/login.service";
import { environment } from "../../../environments/environment";
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import {
	FormGroup,
	FormBuilder
} from '@angular/forms';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { NotifierService } from 'angular-notifier';
import { Location } from '@angular/common';
import { MatDialog } from '@angular/material/dialog';
import { EulaDialogComponent } from '../eula-dialog/eula-dialog.component';
import { UtilService } from '../../services/util.service';
import { ErrorService } from "../../services/error.service";
import { TokenStorageService } from '../../services/token-storage.service';
import { MfaService } from '../../services/mfa/mfa.service';
import { BootController } from '../../../boot-control';

@Component({
	selector: 'app-mfa',
	templateUrl: './mfa.component.html',
	styleUrls: ['./mfa.component.scss']
})
export class MfaComponent implements OnInit {

	private readonly notifier: NotifierService;
	mfaForm: FormGroup;
	errorMessage: string;
	@ViewChild('aForm') aForm: ElementRef;
	isError: boolean = false;
	@BlockUI() blockUI: NgBlockUI;
	private asgAdminUrl = environment.asgAdminUrl;
	constructor(
		private router: Router,
		private fb: FormBuilder,
		private notifierService: NotifierService,
		private http: HttpClient,
		private mfaService: MfaService,
		private loginService: LoginService,
		private tokenStorageService:TokenStorageService,
		private utilService: UtilService,
		private ngZone: NgZone,
		private changedetect: ChangeDetectorRef,
		private errorService:ErrorService,
		private location: Location,
		public dialog: MatDialog
	) {
		this.notifier = notifierService;
		this.mfaForm = fb.group({
			'digit1': [null],
			'digit2': [null],
			'digit3': [null],
			'digit4': [null],
			'digit5': [null],
			'digit6': [null],
		});
	}

	ngOnInit() { }

	ngAfterViewInit() {
		this.aForm.nativeElement['digit1'].focus();
		this.changedetect.detectChanges();
	}
	regenerateQRCode(event){ 
		event.stopPropagation();
		event.preventDefault();
		this.notifier.hide('doLogin');
		let userName = window.sessionStorage.getItem('loginUserName');
		if(userName){
			this.mfaService.generateQrForUserForMFA(userName).subscribe((myRes: HttpResponse<any>) => {
				this.notifier.getConfig().behaviour.autoHide = 5000;
				this.notifier.notify('success', 'QR code generation instructions have been sent to the registered Email address.');
			},
			err => {
				this.notifier.getConfig().behaviour.autoHide = false;
				this.notifier.notify('error', this.errorService.errorMsg, "doLogin");
			});
		}else{
			this.notifier.getConfig().behaviour.autoHide = false;
			this.notifier.notify('error', this.errorService.errorMsg, "doLogin");
		}
		return false;
	}

	keytab(event, prevDigit, currDigit, nextDigit) {
		this.isError = false;
		if (event.target.value != null && event.target.value.length > 1) {
			this.mfaForm.controls[currDigit].setValue(event.target.value.substr(event.target.value.length - 1, 1));
		}

		const values = Object.keys(this.mfaForm.value).map(key => this.mfaForm.value[key]);
		if (event.key == "Backspace") {
			const ele = this.aForm.nativeElement[prevDigit];
			if (ele) {
				ele.focus();
				this.mfaForm.controls[prevDigit].setValue(null);
			}
		}else if (event.key == "Delete") {
			const ele = this.aForm.nativeElement[nextDigit];
			if (ele) {
				ele.focus();
				this.mfaForm.controls[nextDigit].setValue(null);
			}
		}
		else if (nextDigit != null && event.target.value != null && event.target.value.length == 1) {
			const ele = this.aForm.nativeElement[nextDigit];
			if (ele) {
				ele.focus();
			}
		} else if (!(values.includes("") || values.includes(null))) {
			const ele = this.aForm.nativeElement[currDigit];
			if (ele) {
				ele.blur();
			}
			let digitKeys = Object.keys(this.mfaForm.value); let otpToken = "";
			for (let i = 0; i < digitKeys.length; i++) {
				otpToken = otpToken + this.mfaForm.controls[digitKeys[i]].value;
			}
			this.mfaSignOn(otpToken);
		}
	}

	mfaSignOn(otpToken) {
		this.notifier.hide('doLogin');
		let elementList = document.querySelectorAll('.eror-head');
		for (let index = 0; index < elementList.length; index++) {
			elementList[index].classList.remove('eror-head');
		}
		let data;

		this.mfaService.mfaSignOn(otpToken).subscribe((myRes: HttpResponse<any>) => {
			this.isError = false;
			this.signonSucces(myRes);
		},
		err => {
			this.signonEror();  //  MFA SignOn Error Animation code
		});
	}

	signonEror() {
		let elementList = document.querySelectorAll('.width-16');
		let inpList = document.querySelectorAll('.inp-sty');
		for (let index = 0; index < elementList.length; index++) {
			elementList[index].classList.add('eror-head');
			inpList[index].classList.add('error-transs');
		}
		this.isError = true;
		setTimeout(() => {
			this.mfaForm.reset();
			for (let index = 0; index < elementList.length; index++) {
				elementList[index].classList.remove('eror-head');
				inpList[index].classList.remove('error-transs');
			}
			this.aForm.nativeElement['digit1'].focus();
			this.changedetect.detectChanges();
		}, 1000);
	}
 
	signonSucces(data) {
		let elementList = document.querySelectorAll('.width-16');
		let inpList = document.querySelectorAll('.inp-sty');
		for (let index = 0; index < elementList.length; index++) {
			elementList[index].classList.add('transs');
			inpList[index].classList.add('transs');
		}
		setTimeout(() => {
			this.loginSuccess(data);			
		}, 2000);
	}


	loginSuccess(data) {
		if (data.eulaEnabled === 'y' &&
		(data.eulaAccepted === 'n' || !data.eulaAccepted)) {
		  const dialogRef = this.dialog.open(EulaDialogComponent, {
			autoFocus: false,
			disableClose: true,
			data: { userRsp : data}
		  });
		}  else {
		  window.sessionStorage.setItem("loggedInUser", JSON.stringify(data));
		  window.sessionStorage.setItem("setPassword", data.changePassword);
		  localStorage.setItem("loggedInUser", JSON.stringify(data));
		  localStorage.setItem("setPassword", data.changePassword);
		  this.loginService.navigateToHomePage();
		}
	  }	
	  
	gotoLoginPage(event){ 
		event.stopPropagation();
		event.preventDefault();
		this.loginService.logout().then(data => {
		localStorage.removeItem('AuthorizationD');
		localStorage.removeItem('JSESSIONID');
		localStorage.removeItem('token');
		localStorage.removeItem('expires_at');
		localStorage.removeItem('selectedTile');
		localStorage.removeItem('widgets');
		localStorage.removeItem('loggedInUser');
		localStorage.removeItem('userId');
		localStorage.removeItem('setPassword');
		localStorage.removeItem('orgConfig');
		this.tokenStorageService.signOut();
		// Triggers the reboot in main.ts
		this.ngZone.runOutsideAngular(() => BootController.getbootControl().restart());
		this.router.navigate(['/login']);
    },
    error => {
      console.error("error on disagreeing eula");
    });
  }
}
